import { useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { verifyOtpApi } from '../services/authApi'
import '../responsive.css'
import '@fontsource/inter'

function OtpVerify() {
  const location = useLocation()
  const navigate = useNavigate()
  const mobile = location.state?.mobile || ''

  const [otp, setOtp] = useState(['', '', '', '', '', ''])
  const [loading, setLoading] = useState(false)
  const inputRefs = useRef([])

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return

    const updatedOtp = [...otp]
    updatedOtp[index] = value
    setOtp(updatedOtp)

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handleVerifyOtp = async () => {
  const finalOtp = otp.join('')

  if (finalOtp.length !== 6) {
    alert('Enter valid 6-digit OTP')
    return
  }

  setLoading(true)

  const response = await verifyOtpApi(mobile, finalOtp)

  console.log('VERIFY OTP RESPONSE:', response)

// =====================================================
// RESTORE FLOW
// =====================================================

if (
  response?.action_required ===
  'restore_prompt'
) {

  localStorage.setItem(
    'token',
    response.token
  )

  localStorage.setItem(
    'login_token',
    response.token
  )

  localStorage.setItem(
    'mobile',
    mobile
  )

  localStorage.setItem(
    'user_id',
    response.user_id
  )

  window.location.href = '/restore'

}

// =====================================================
// NORMAL LOGIN
// =====================================================

else if (
  response?.status === true ||
  response?.status === 'true'
) {

  localStorage.setItem(
    'token',
    response.token
  )

  localStorage.setItem(
    'login_token',
    response.token
  )

  localStorage.setItem(
    'mobile',
    mobile
  )

  localStorage.setItem(
    'user_id',
    response.user_id
  )

  window.location.href = '/dashboard'

}

// =====================================================
// ERROR
// =====================================================

else {

  alert(
    response?.message ||
    'Invalid OTP'
  )

}

  setLoading(false)
}

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useState(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div style={{
      ...styles.page, 
      padding: isMobile ? '10px' : '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }} className="app-page">
      <div style={{
        ...styles.topBar,
        width: '100%',
        borderRadius: isMobile ? '12px' : '18px',
        padding: isMobile ? '10px 14px' : '14px 20px',
        marginBottom: isMobile ? '10px' : '14px'
      }}>
        <div style={{...styles.topBrand, justifyContent: isMobile ? 'center' : 'flex-start'}}>
          <img src="/logo.png" alt="Moxpal Logo" style={{...styles.topLogo, height: isMobile ? '28px' : '32px'}} />
          <span style={{...styles.topBrandText, fontSize: isMobile ? '14px' : '16px'}}>Moxpal Khata Web</span>
        </div>
      </div>

      <div style={{
        ...styles.wrapper,
        width: '100%',
        minHeight: isMobile ? 'calc(100vh - 80px)' : 'calc(100vh - 110px)',
        borderRadius: isMobile ? '20px' : '24px',
        padding: isMobile ? '20px 10px' : '0'
      }}>
        <div style={{
          ...styles.card,
          maxWidth: isMobile ? '100%' : '420px',
        }}>
          <div style={styles.logoWrap}>
            <img src="/praying-hands.png" alt="Verify OTP" style={{...styles.logo, height: isMobile ? '44px' : '54px'}} />
          </div>

          <h1 style={{...styles.title, fontSize: isMobile ? '24px' : '28px'}}>Verify OTP</h1>

          <p style={styles.subtitle}>
            Enter the 6-digit code sent to WhatsApp <br />
            <span style={styles.mobile}>{mobile}</span>
          </p>

          <div style={{...styles.otpWrap, gap: isMobile ? '6px' : '8px'}}>
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                value={digit}
                maxLength={1}
                inputMode="numeric"
                style={{
                  ...styles.otpInput,
                  width: isMobile ? '40px' : '48px',
                  height: isMobile ? '48px' : '56px',
                  fontSize: isMobile ? '18px' : '20px',
                  borderRadius: isMobile ? '10px' : '14px'
                }}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            ))}
          </div>

          <button
            style={styles.button}
            onClick={handleVerifyOtp}
            disabled={loading}
          >
            {loading ? 'Verifying...' : 'Verify & Continue'}
          </button>

          <p style={styles.secure}>🔒 Secure OTP verification</p>
        </div>
      </div>
    </div>
  )
}

const styles = {
  page: {
    width: '100%',
    minHeight: '100vh',
    padding: '20px',
    backgroundColor: '#F8FAFC',
    fontFamily: 'Inter, Arial, sans-serif',
  },

  topBar: {
    width: '100%',
    maxWidth: '1320px',
    margin: '0 auto 14px auto',
    backgroundColor: '#ffffff',
    borderRadius: '18px',
    padding: '14px 20px',
    boxShadow: '0 8px 24px rgba(15,23,42,0.04)',
  },

  topBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },

  topLogo: {
    height: '32px',
  },

  topBrandText: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#0F172A',
  },

  wrapper: {
    width: '100%',
    maxWidth: '1320px',
    minHeight: 'calc(100vh - 110px)',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '24px',
    boxShadow: '0 12px 40px rgba(15,23,42,0.06)',
  },

  card: {
    width: '100%',
    maxWidth: '420px',
    padding: '10px',
  },

  logoWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },

  logo: {
    height: '54px',
    objectFit: 'contain',
  },

  title: {
    textAlign: 'center',
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: '10px',
  },

  subtitle: {
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '24px',
    color: '#64748B',
    marginBottom: '26px',
  },

  mobile: {
    fontWeight: '600',
    color: '#0F172A',
  },

  otpWrap: {
    display: 'flex',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '24px',
  },

  otpInput: {
    width: '48px',
    height: '56px',
    border: '1.5px solid #CBD5E1',
    borderRadius: '14px',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: '600',
    outline: 'none',
    color: '#0F172A',
  },

  button: {
    width: '100%',
    height: '52px',
    border: 'none',
    borderRadius: '14px',
    backgroundColor: '#2563EB',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
  },

  secure: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#64748B',
  },
}

export default OtpVerify